module.exports = __webpack_public_path__ + "img/vipbtn.8f20ebfb.png";